import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Accordion from '@material-ui/core/Accordion';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  hasCaseNotes: {
    backgroundColor: theme.palette.success.light
  }
}));

const NotesWrapper = ({ title, children, type, hasNotes }) => {
  const classes = useStyles();
  const titleClassNames = [];
  if (type === 'case_notes' && hasNotes) {
    titleClassNames.push(classes.hasCaseNotes);
  }

  return (
    <Accordion>
      <AccordionSummary className={titleClassNames.join(' ')} expandIcon={<ExpandMoreIcon />}>
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

NotesWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  hasNotes: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.object
};

NotesWrapper.defaultProps = {
  type: null,
  hasNotes: false,
  children: {}
};

export default NotesWrapper;
